export const styles = {
  paper: (maxWidth) => (theme) => ({
    p: { xs: 2.5, sm: 3 },
    maxWidth: maxWidth || 540,
    width: "100%",
    borderRadius: 3,
    backgroundColor: theme.palette.background.default,
    position: "relative",
    overflow: "hidden",
  }),
  closeButton: (theme) => ({
    position: "absolute",
    top: 12,
    right: 12,
    color: theme.palette.grey?.[500],
  }),
  content: {
    p: "0 !important",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    overflow: "visible !important",
    overflowX: "visible !important",
    overflowY: "visible !important",
  },
  iconWrapper:
    (iconColor = "blueBright", iconBgColor) =>
    (theme) => {
      const colors = {
        blueBright: {
          color: theme.palette.primary.blueBright,
          bg: theme.palette.primary.blueBrightBg,
        },
        error: {
          color: theme.palette.error.main,
          bg: theme.palette.danger.secondary,
        },
        warning: {
          color: theme.palette.warning.dark,
          bg: theme.palette.warning.bannerBg,
        },
        success: {
          color: theme.palette.success.dark,
          bg: theme.palette.success.lighter,
        },
      }
      const active = colors[iconColor] || colors.blueBright

      return {
        width: 52,
        height: 52,
        borderRadius: "50%",
        backgroundColor: iconBgColor || active.bg,
        color: active.color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 2,
      }
    },
  title: (theme) => ({
    mb: 1,
    fontWeight: 700,
  }),
  description: (theme) => ({
    mb: 3,
  }),
  actions: {
    display: "flex",
    flexDirection: "row",
    gap: 1.5,
    width: "100%",
    justifyContent: "center",
  },
  actionBtn: (theme) => ({
    flex: 1,
    textTransform: "none",
    whiteSpace: "normal",
    wordBreak: "break-word",
    textAlign: "center",
  }),
}
